import * as React from 'react';

interface Props {
	location?: any;
	className?: string;
	children?: {};
}

// https://reacttraining.com/react-router/web/guides/scroll-restoration

class ScrollToTop extends React.Component<Props> {
	componentDidUpdate(prevProps: any) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0);
		}
	}

	render() {
		return <div className={this.props.className}>{this.props.children}</div>;
	}
}

export default ScrollToTop;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/ScrollToTop.tsx